

export const params = {
    height: window.innerHeight,
    width: window.innerWidth,
    aspect: window.innerWidth / window.innerHeight,
    videoTexturePath: "/video/wallpaper-mac.mp4"
}

export const cameraPosition = {
    x: 8.365196560533881,
    y: 8.145626110602074,
    z: -12.6662315161195904,
}

export const cameraTarget = {
    x:-0.189941195896174,
    y: 1.8772718124625551,
    z:-0.2097330786842654
}

export const texturesPaths = {
    base: "/textures/bg.webp",
    bed: "/textures/bed.webp",
    rubicks_target_hover: "/textures/bed.webp",
    books: "/textures/books.webp",
    chess_target_hover: "/textures/chessboard.webp",
    chess_table: "/textures/chtable.webp",
    desktop: "/textures/desktop.webp",
    drawer: "/textures/drawer_vin_bask.webp",
    earth_globe: "/textures/globe.webp",
    floor: "/textures/floor.webp",
    gaming_chair: "/textures/gaming_chair.webp",
    hanging_lights: "/textures/lights.webp",
    keyboard: "/textures/keyboard.webp",
    mac: "/textures/mac.webp",
    naruto_headband: "/textures/naruto.webp",
    plants: "/textures/plants.webp",
    ps5: "/textures/ps5.webp",
    wall: "/textures/wall.webp",
    github_target_logo: "/textures/github.webp",
    jin_sakai_target_hover: "/textures/jin_sakai.webp",
    linkedin_target_logo: "/textures/linkedin.webp",
    malenia_target_hover: "/textures/malenia.webp",
    luv_sic_target_paper: "/textures/luv.webp",
    modal_soul_target_paper: "/textures/soul.webp",
    vagabond_target_paper: "/textures/vagabond.webp",
    minibox_1_target_hover: "textures/desktop.webp",
    minibox_2_target_hover: "textures/desktop.webp",
    minibox_3_target_hover: "textures/desktop.webp",
    lamp_target_hover: "textures/bed.webp",
    vinyl: "textures/drawer_vin_bask.webp",
    mug_target_hover: "textures/desktop.webp",
    mug_support: "textures/desktop.webp",
    ball: "textures/drawer_vin_bask.webp"
}

export const socialLinks = {
    github_target_logo: "https://github.com/toranogix",
    linkedin_target_logo: "https://www.linkedin.com/in/cheick-oumar-diallo-b3122920a/",
}

export const desktopUrl = "https://romangix-os.vercel.app/"

/** Clickable objects that open the passion panel (mesh name must include the key). */
export const passionInfo = {
    chess_target_hover: {
        title: "Chess",
        description:
            "Chess is one of my favorite ways to think quietly and to relax. I love the tension of a long game (not always but most of the time). " + 
            "Reading the board, sacrificing pieces and finding that one move that flips everything is what makes it so addictive and enjoyable. " +
            "Not playing with an official chess account but I'm getting there soon (^ ^).",
        image: "images/chess.gif",
    },
    earth_globe: {
        title: "Maps",
        description:
            "I love MAPS. And I’m endlessly curious about the world: cultures and cities I’ve never seen. I would have love to live at the time of the great explorers to discover new places that were not yet discovered. " +
            "This globe is a reminder that there’s always another place to learn about, another story across the globe.",
        image: "images/earth.gif",
    },
    naruto_headband: {
        title: "Naruto & Anime",
        description:
            "Naruto was more than a show for me (it's the best anime ever no doubt about it). It was motivation wrapped in friendship and stubborn hope and optimism. " +
            "Anime still shapes how I think about characters, worlds and storytelling.",
        image: "images/naruto.gif",
    },
    jin_sakai_target_hover: {
        title: "Ghost of Tsushima",
        description:
            " Honor died on the beach - Jin Sakai. It's undoubtely one of the best games ever made. Jin Sakai’s journey stuck with me with its beauty and storytelling about: How far are you willing to go to protect your people and land in times of conflict ?. Ghost of Tsushima is one of those games that feels like cinema.",
        image: "images/got.gif",
    },
    malenia_target_hover: {
        title: "Elden Ring & Souls",
        description:
            "Malenia, Blade of Miquella (one of the best bosses ever !!!). FromSoftware games taught me to love difficulty and patience. " +
            "You have to learn, adapt and earn every victory. Pure unforgettable gameplay (after a lot of hours).",
        image: "images/malenia.gif",
    },
    luv_sic_target_paper: {
        title: "Luv(sic) · Nujabes",
        description:
            "Nujabes’ Luv(sic) is on loop in my head more often than I’d admit. That blend of jazz, hip-hop and quiet emotion is the soundtrack of late nights and deep focus.",
        image: "/textures/luv.webp",
    },
    vagabond_target_paper: {
        title: "Vagabond",
        description:
            "Vagabond isn’t just a manga, it’s a meditation on mastery of your own self. The art, the silence between panels, Musashi’s path… all wrapped up in a beautiful story.",
        image: "/textures/vagabond.webp",
    },
    modal_soul_target_paper: {
        title: "Modal Soul",
        description:
            "Modal Soul is one of those albums that feels like a place. Smooth, reflective and perfect. Nujabes at his most immersive. Music for coding, creating, and zoning out.",
        image: "/textures/soul.webp",
    },
    rubicks_target_hover: {
        title: "Rubik’s Cube",
        description:
            "Twisting a cube until the colors snap into place scratches a special itch. That small dopamine hit when the last face solves is just pure puzzle joy (it's not easy but it's worth it). Love both 3x3 and 4x4 cubes.",
        image: "images/cube.gif",
    },
    gis_letter: {
        title: "GIS",
        description:
            "Geographic Information Systems fascinate me. Turning raw spatial data into maps that tell a story. It’s where geography, code and visualization meet (love it !!! I'm a GIS specialist).",
        image: "images/gis.gif",
    },
    lis: {
        title: "Life is Strange",
        description:
            "One of the best games ever made. Life is Strange hits hard with atmosphere and those quiet teenage moments that stick. It’s the kind of story-driven game that stays with you long after the credits (RIP Chloe Price). The soundtrack is also one of the best ever made (and you're listening to it right now).",
        image: "images/lis.gif",
    },
    threejs: {
        title: "Three.js",
        description:
            "Three.js is a JavaScript library that allows you to create 3D graphics in the browser. I used it to create this portfolio website (love it !!!).",
        image: "images/threejs.gif",
    }, 
}